import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatErr } from "../lib/api";
import { Radio } from "lucide-react";

export default function TeacherLogin() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("admin@sarkideyim.tr");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null); setLoading(true);
    try {
      await login(email, password);
      nav("/teacher");
    } catch (e) { setErr(formatErr(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen dark bg-[#070B14] text-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-10 justify-center">
          <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-cyan-400 to-violet-500 flex items-center justify-center">
            <Radio className="h-5 w-5 text-black" />
          </div>
          <span className="font-heading font-bold tracking-tight">Şarkı Söyleyen Deyimler</span>
        </Link>
        <div className="rounded-3xl border border-white/10 bg-zinc-950/70 backdrop-blur-xl p-8">
          <h1 className="font-heading text-2xl font-bold">Öğretmen Girişi</h1>
          <p className="text-zinc-400 text-sm mt-1">Canlı oyun oluşturmak için giriş yap.</p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="text-xs font-heading text-zinc-400 tracking-wider">E-POSTA</label>
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="mt-2 w-full rounded-xl bg-black/60 border border-white/10 px-4 py-3 focus:outline-none focus:border-cyan-400"
                required autoFocus
              />
            </div>
            <div>
              <label className="text-xs font-heading text-zinc-400 tracking-wider">ŞİFRE</label>
              <input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="mt-2 w-full rounded-xl bg-black/60 border border-white/10 px-4 py-3 focus:outline-none focus:border-cyan-400"
                required
              />
            </div>
            {err && <div className="text-red-300 text-sm" data-testid="login-error">{err}</div>}
            <button
              type="submit" disabled={loading} data-testid="login-submit"
              className="w-full rounded-full bg-gradient-to-r from-cyan-400 to-violet-500 text-black font-heading font-bold py-3 hover:opacity-90 transition disabled:opacity-50"
            >
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </form>

          <div className="mt-6 text-xs text-zinc-500">
            Demo hesap: <span className="text-zinc-300">admin@sarkideyim.tr</span> / <span className="text-zinc-300">SarkiDeyim2026!</span>
          </div>
        </div>
      </div>
    </div>
  );
}
